import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const DocumentPage = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate("/login");
    }
  }, [user, navigate]);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4" data-testid="document-page">
      {/* Word-like document */}
      <div className="w-full max-w-[816px] min-h-[1056px] bg-white shadow-[0_0_10px_rgba(0,0,0,0.1)] p-16 relative" style={{ fontFamily: 'Calibri, Arial, sans-serif' }}>
        {/* Word-style header bar */}
        <div className="absolute top-0 left-0 right-0 h-1 bg-[#2b579a]"></div>
        
        {/* Document content */}
        <div className="space-y-6">
          <p className="text-[18px] font-bold text-black leading-relaxed">
            Hallo Victor,
          </p>
          
          <p className="text-[14px] text-black leading-[1.8]">
            sei froh, dass dies keine echte Phishing Mail war. Bitte prüf deine E-Mails immer genau. Wir tun unser bestes deine Systeme zu sichern. Den Faktor Mensch (jeder User), muss aber seinen Teil tun.
          </p>
          
          <p className="text-[14px] text-black leading-[1.8]">
            Liebe Grüße an deine Familie und damit bist du hier fertig ;)
          </p>
          
          <p className="text-[14px] font-bold text-black leading-relaxed mt-8">
            Dein ITS Greuel Team
          </p>
        </div>

        {/* Word-style footer */}
        <div className="absolute bottom-8 left-16 right-16 flex justify-between text-[10px] text-gray-400 border-t pt-4">
          <span>Wichtige_Mitteilung.docx</span>
          <span>Seite 1 von 1</span>
        </div>
      </div>
    </div>
  );
};

export default DocumentPage;
